import {Component, Input, OnInit} from '@angular/core';
import { AppTitleService } from 'src/app/app-title.service';
import { mobile } from 'src/app/consts/utilities';
import { DashboardService } from 'src/app/dashboard.service';

@Component({
    selector: 'app-auth-tab',
    templateUrl: './auth-tab.component.html',
    styleUrls: ['./auth-tab.component.scss']
})
export class AuthTabComponent implements OnInit {
    public isMobile: boolean;
    public selectedIndex: number;

    @Input() userNeedsRecovery = false;

    constructor(
        private dashboard: DashboardService,
        private titleService: AppTitleService
    ) {
        this.titleService.setTitle('Acceso');
    }

    ngOnInit() {
        this.isMobile = this.dashboard.isMobile;
        this.dashboard.isMobile$.subscribe((value) => {
            this.isMobile = value;
        });
        this.selectedIndex = 0;
    }

    goToLogin() {
        this.selectedIndex = 0;
    }

    getTabIndex(tabIndex: number): void {
        this.selectedIndex = tabIndex;
    }

    displayRecovery(): void {
        this.userNeedsRecovery = true;
    }

    get mobile(): boolean {
        return mobile();
    }
}
